import { render } from "./MaterialsHeadsets.vue?vue&type=template&id=2645956c"
import script from "./MaterialsHeadsets.vue?vue&type=script&lang=js"
export * from "./MaterialsHeadsets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__